// extracted by mini-css-extract-plugin
export default {"container":"EmailView_container__h01MR","label":"EmailView_label__GiAfT","body":"EmailView_body__HcJIF"};